import React, {setState, useState, useEffect} from 'react';
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import PropTypes from 'prop-types';
import { makeStyles, useTheme, alpha } from '@material-ui/core/styles';
import styles from "./Whites.module.css";
import Container from '@material-ui/core/Container'
import { useLocation } from 'react-router-dom';
import {DataGrid, GridToolbar, GridCellEditStopReasons} from "@mui/x-data-grid";
import { deleteWhite } from '../../actions/whiteActions';
import NoData from '../svgIcons/NoData';
import Spinner from '../Spinner/Spinner'
import { useSnackbar } from 'react-simple-snackbar'
import { Button } from '@material-ui/core';
import useAuthUser from '../../hooks/useAuthUser'
import { fetchWhiteList } from '../../api';
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),

  },
}));

const useStyles2 = makeStyles(theme => ({
  table: {
    minWidth: 500,
    
  },

  tablecell: {
    fontSize: '16px'
}
}));

const tableStyle = { width: 160, fontSize: 14, cursor: 'pointer', borderBottom: 'none',  padding: '8px', textAlign: 'center' }
const headerStyle = { borderBottom: 'none', textAlign: 'center'}

const WHITE_GRID_STATE_KEY = 'wholesaleUsaWhiteGridState:v2';
const DEFAULT_WHITE_GRID_STATE = {
  filterModel: { items: [] },
  sortModel: [{ field: 'receivedByDate', sort: 'desc' }],
  paginationModel: { page: 0, pageSize: 50 },
};

const readWhiteGridState = () => {
  try {
    const stored = window.sessionStorage.getItem(WHITE_GRID_STATE_KEY);
    if (!stored) return DEFAULT_WHITE_GRID_STATE;
    const parsed = JSON.parse(stored);
    return {
      filterModel: parsed?.filterModel || DEFAULT_WHITE_GRID_STATE.filterModel,
      sortModel: Array.isArray(parsed?.sortModel) ? parsed.sortModel : DEFAULT_WHITE_GRID_STATE.sortModel,
      paginationModel: parsed?.paginationModel || DEFAULT_WHITE_GRID_STATE.paginationModel,
    };
  } catch {
    return DEFAULT_WHITE_GRID_STATE;
  }
};


const Whites = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const authData = useAuthUser()
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [clientOptions, setClientOptions] = useState([]);
  const [todayBoundaryWhiteId, setTodayBoundaryWhiteId] = useState('');
  const [listLoading, setListLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [gridState, setGridState] = React.useState(readWhiteGridState);
  const isLoading = listLoading;
        // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const statuses = ['Unpaid', 'Paid', 'Partial']
  const clientArray = React.useMemo(() => {
    if (clientOptions.length) return clientOptions;
    return [...new Set((rows || []).map((invoice) => invoice?.client?.store).filter(Boolean))].sort();
  }, [clientOptions, rows]);

    const formatDollarsToCents = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    if (value && value.includes('.')) {
        value = value.substring(0, value.indexOf('.') + 3);
    }
  
    return value ? Math.round(parseFloat(value) * 100) : 0;
  };
  
  const formatCentsToDollars = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    value = parseFloat(value);
    return value ? value / 100 : 0;
  };

  // Create our number formatter.
const dollar_formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});

  const displayAsDollars = function(params) {
    return dollar_formatter.format(formatCentsToDollars(params))
  }


  // const rows = []


    // useEffect(() => {
    //     dispatch(getWhites());
    // }, [dispatch]);

    const updateGridState = React.useCallback((updater) => {
      setGridState((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater };
        try {
          window.sessionStorage.setItem(WHITE_GRID_STATE_KEY, JSON.stringify(next));
        } catch {
          // Ignore storage failures so the grid remains usable.
        }
        return next;
      });
    }, []);

    useEffect(() => {
      let cancelled = false;
      setListLoading(true);
      fetchWhiteList({
        page: gridState.paginationModel?.page || 0,
        pageSize: gridState.paginationModel?.pageSize || 20,
        filters: gridState.filterModel?.items || [],
        sortModel: gridState.sortModel || [],
      })
        .then(({ data }) => {
          if (cancelled) return;
          setRows(data?.data || []);
          setRowCount(Number(data?.total || 0));
          setClientOptions(data?.clientOptions || []);
          setTodayBoundaryWhiteId(data?.todayBoundaryWhiteId || '');
        })
        .catch((error) => {
          console.log(error?.response || error);
          if (!cancelled) {
            setRows([]);
            setRowCount(0);
          }
        })
        .finally(() => {
          if (!cancelled) setListLoading(false);
        });
      return () => {
        cancelled = true;
      };
    }, [gridState.filterModel, gridState.paginationModel, gridState.sortModel, refreshKey]);

   const toCommas = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows.length);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

    const columns = [
      {
        field: 'client',
        headerName: 'Client',
        type: 'singleSelect',
        valueOptions: clientArray,
        editable: false,
        minWidth: 125,
        flex: 1,
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          const valueFormatted = params.value.store;
          return valueFormatted;
        }, 
      },
      { 
        field: 'total', 
        headerName: 'Amount', 
        flex: 1,
        minWidth: 100, 
        editable: false,
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          const valueFormatted = '$' + toCommas(params.value);
          return valueFormatted;
        },  
      },
      { 
        flex: 1,
        minWidth: 150,
        field: 'receivedByDate', 
        headerName: 'Received Date', 
        width: 150, 
        editable: false,
        type: 'date',
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
          // return valueFormatted;
          const valueFormatted = new Date(params.value);
          return valueFormatted;
        },
      },
      { 
        flex: 1,
        minWidth: 150,
        field: 'dueDate', 
        headerName: 'Due Date', 
        width: 150, 
        editable: false,
        type: 'date',
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
          // return valueFormatted;
          const valueFormatted = new Date(params.value);
          return valueFormatted;
        },
      },
      { field: 'status', 
        headerName: 'Status', 
        width: 125, 
        type: 'singleSelect',
        valueOptions: statuses,
        renderCell: (params) => {
        return (
          <button style={checkStatus(params.value)}>{params.value}</button>
        );
      } },
      { field: 'actions', headerName: 'Actions', headerAlign: 'center', align: 'center', flex:1, minWidth: 200, renderCell: (params) => {
        return (
          <div style={{display: 'flex'}}>
            <Button
              style={{color: 'white', backgroundColor: 'rgb(25, 118, 210)', marginRight: 10}}
              onClick={() => editWhite(params.row._id)}
              variant="contained"
            >
              Edit
            </Button>
            <Button
              style={{color: 'white', backgroundColor: 'red'}}
              onClick={async (e) => {
                e.stopPropagation();
                await dispatch(deleteWhite(params.row._id, openSnackbar));
                setRefreshKey((value) => value + 1);
              }}
              variant="contained"
            >
              Delete
            </Button>
              
    
          </div>
          
        );
      } }
    ];


  const editWhite = (id) => {
    history.push(`/edit/white/${id}`)
  }

  const openWhite = (id) => {

    history.push(`/white/${id}`)
  }

  const hasActiveGridFilters = React.useMemo(() => (
    (gridState.filterModel?.items || []).some((item) => item?.value !== undefined && item?.value !== null && item?.value !== '')
  ), [gridState.filterModel]);

  if(!authData) {
    history.push('/login')
  }



  function checkStatus(status) {
    return status === "Partial" ? {border: 'solid 0px #1976d2', backgroundColor: '#baddff', padding: '8px 18px', borderRadius: '20px' }
        : status === "Paid" ? {border: 'solid 0px green', backgroundColor: '#a5ffcd', padding: '8px 18px', borderRadius: '20px' }
        : status === "Unpaid" ? {border: 'solid 0px red', backgroundColor: '#ffaa91', padding: '8px 18px', borderRadius: '20px' }
        : "red";
          
}

  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

  if(!isLoading && rows.length === 0 && rowCount === 0 && !hasActiveGridFilters) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
      <NoData />
    <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No white yet. Click the plus icon to create white</p>
  
    </div>
  }

  return (
      <div className={styles.pageLayout}>
        <Container style={{maxWidth: 1600}}>
          <div className={styles.buttons}>
          <h1 style={{paddingTop: 10}}>Whites</h1>
          </div>
          <div className={styles.gridLayout}>
                <DataGrid
                    sx={{
                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '8px' },
                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '12px' },
                  }}
                  autoHeight
                  rows={rows}
                  getRowId={(row) => row._id}
                  getRowHeight={() => 'auto'}
                  columns={columns}
                  loading={listLoading}
                  rowCount={rowCount}
                  paginationMode="server"
                  sortingMode="server"
                  filterMode="server"
                  filterModel={gridState.filterModel}
                  onFilterModelChange={(filterModel) => updateGridState((prev) => ({
                    ...prev,
                    filterModel,
                    paginationModel: { ...prev.paginationModel, page: 0 },
                  }))}
                  sortModel={gridState.sortModel}
                  onSortModelChange={(sortModel) => updateGridState({ sortModel })}
                  paginationModel={gridState.paginationModel}
                  onPaginationModelChange={(paginationModel) => updateGridState({ paginationModel })}
                  pageSizeOptions={[20, 50, 100]}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                  onRowClick={(row) => openWhite(row.id)}
                  sortingOrder={['desc','asc']}
                  getRowClassName={(params) => (
                    String(params.id || '') === String(todayBoundaryWhiteId || '') ? styles.todayBoundaryRow : ''
                  )}
                />
            </div>
        </Container>
      </div>
    
    );
}

export default Whites
